import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { api, GetWaitlistSubscriptionStatusResponse } from 'services';
import { StateCode, SubscribeToWaitlistSagaRequest, WaitlistSubscription, WaitlistSubscriptionStatus } from 'state/types';
import createAsyncSaga from '../createAsyncSaga';
import { FEATURE_NAME, upsertSubscriptionStatus } from './slice';

export const getWaitlistSubscriptionStatusSaga = createAsyncSaga<void, StateCode>(
    `${FEATURE_NAME}/saga/getWaitlistSubscriptionStatus`,
    function* (request: StateCode) {
        const response: AxiosResponse<GetWaitlistSubscriptionStatusResponse> = yield call(api.getWaitlistSubscriptionStatus, {
            waitlistId: "GA_ST_WL",
            discriminator: request
        });
        const status: WaitlistSubscription = {
            stateCode: request,
            status: response.data.status
        }
        yield put(upsertSubscriptionStatus(status));
    }
);
function* watchGetWaitlistSubscriptionStatus() {
    yield takeLatest(getWaitlistSubscriptionStatusSaga.type, getWaitlistSubscriptionStatusSaga.saga);
}

export const subscribeToWaitlistSaga = createAsyncSaga<void, SubscribeToWaitlistSagaRequest>(
    `${FEATURE_NAME}/saga/subscribeToWaitlist`,
    function* (request: SubscribeToWaitlistSagaRequest) {
        const response: AxiosResponse<void> = yield call(api.subscribeToWaitlist, {
            waitlistId: "GA_ST_WL",
            discriminator: request.stateCode,
            enrollmentSource: request.asin
        });
        const status: WaitlistSubscription = {
            stateCode: request.stateCode,
            status: WaitlistSubscriptionStatus.ACTIVE
        }
        yield put(upsertSubscriptionStatus(status));
    }
);
function* watchSubscribeToWaitlist() {
    yield takeLatest(subscribeToWaitlistSaga.type, subscribeToWaitlistSaga.saga);
}


export default function* sagas() {
    yield all([
        fork(watchGetWaitlistSubscriptionStatus),
        fork(watchSubscribeToWaitlist),
    ]);
}